module.exports = __webpack_public_path__ + "assets/img/fashion-img5-afb9e7bd.png";